<template>
  <b-button
    id="new-convo-button"
    block
    pill
    variant="info"
    :disabled="!$permission('create:conversation')"
    @click="() => open()"
  >
    New Conversation
  </b-button>
</template>

<script>
import { EventBus } from "../../events/eventBus";
import NewConversationForm from "../conversations/NewConversationForm";

export default {
  name: "NewConversationButton",
  methods: {
    open() {
      const $ = window.$;
      $("#id-modal-container").modal({
        backdrop: "static"
      });
      EventBus.$emit("open", {
        component: NewConversationForm,
        title: "New Conversation",
        actionButton: "Start Conversation",
        closeOnClick: true,
      });
    }
  }
};
</script>
